import api from '@/services/Api';
import { ActionContext, Module } from 'vuex';
import { AxiosResponse } from 'axios';
import { RootState, ZahlungsartenState } from '@/store/types';
import Zahlungsart from '@/types/Zahlungsart';

type Context = ActionContext<ZahlungsartenState, RootState>;

export const zahlungsarten: Module<ZahlungsartenState, RootState> = {
    namespaced: true,
    state: {
        arten: [],
        loaders: {
            arten: false,
        },
    },
    actions: {
        loadZahlungsarten({ commit }: Context): void {
            commit('setLoadersZahlungsarten', true);

            api.post('ivs/zahlungsarten/load')
                .then((response: AxiosResponse) => commit('setZahlungsarten', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersZahlungsarten', false));
        },
    },
    mutations: {
        setZahlungsarten(state: ZahlungsartenState, arten: Zahlungsart[]): void {
            state.arten = arten;
        },
        setLoadersZahlungsarten(state: ZahlungsartenState, loading: boolean): void {
            state.loaders.arten = loading;
        },
    },
};
